import "./styles.scss"
import { Modal, Image, Container } from "react-bootstrap"
import PropTypes from "prop-types"
import React from "react"
import ETETECHNOLOGY_LOGO from "../../../assets/images/EteTechnology_LOGO_YATAY.png"
import CUBES from "../../../assets/images/careerDetailCubes.png"

const RiskManagementModal = ({ onHide, showModal, state, getLanguageFile }) => {
  return (
    <Modal
      show={showModal}
      onHide={onHide}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      dialogClassName="risk-management-modal"
    >
      {" "}
      <Container fluid className="about-us-image-container">
        <Image className={"about-us-image-background"} src={CUBES} />
      </Container>
      <Modal.Header closeButton></Modal.Header>
      <Modal.Body style={{ padding: "0 4em" }}>
        <Image
          src={ETETECHNOLOGY_LOGO}
          style={{ width: "45%", display: "block" }}
        ></Image>

        <h4 className="modal-sub-title">
          {getLanguageFile(state.language).RiskManagement.title}
        </h4>
        <p className="description">
          {getLanguageFile(state.language).RiskManagement.descriptionOne}
        </p>
        <p className="description">
          {getLanguageFile(state.language).RiskManagement.descriptionTwo}
        </p>
        <p className="description">
          {getLanguageFile(state.language).RiskManagement.descriptionThree}
        </p>
        <p className="description">
          {getLanguageFile(state.language).RiskManagement.descriptionFour}
        </p>
        <ul>
          <li>
            <p className="description bullet">
              {getLanguageFile(state.language).RiskManagement.listItemOne}
            </p>
          </li>
          <li>
            <p className="description bullet">
              {getLanguageFile(state.language).RiskManagement.listItemTwo}
            </p>
          </li>
          <li>
            <p className="description bullet">
              {getLanguageFile(state.language).RiskManagement.listItemThree}
            </p>
          </li>
          <li>
            <p className="description bullet">
              {getLanguageFile(state.language).RiskManagement.listItemFour}
            </p>
          </li>
          <li>
            <p className="description bullet">
              {getLanguageFile(state.language).RiskManagement.listItemFive}
            </p>
          </li>
          <li>
            <p className="description bullet">
              {getLanguageFile(state.language).RiskManagement.listItemSix}
            </p>
          </li>
          <li>
            <p className="description bullet">
              {getLanguageFile(state.language).RiskManagement.listItemSeven}
            </p>
          </li>
          <li>
            <p className="description bullet">
              {getLanguageFile(state.language).RiskManagement.listItemEight}
            </p>
          </li>
          <li>
            <p className="description bullet">
              {getLanguageFile(state.language).RiskManagement.listItemNine}
            </p>
          </li>
          <li>
            <p className="description bullet">
              {getLanguageFile(state.language).RiskManagement.listItemTen}
            </p>
          </li>
          <li>
            <p className="description bullet">
              {getLanguageFile(state.language).RiskManagement.listItemEleven}
            </p>
          </li>
          <li>
            <p className="description bullet">
              {getLanguageFile(state.language).RiskManagement.listItemTwelve}
            </p>
          </li>
        </ul>

        <p className="description">
          {getLanguageFile(state.language).RiskManagement.closingOne}
        </p>
        <p className="description">
          {getLanguageFile(state.language).RiskManagement.closingTwo}
        </p>
        <p className="description">
          {getLanguageFile(state.language).RiskManagement.name}
          <br />
          {getLanguageFile(state.language).RiskManagement.position}
        </p>
        <div className="borderBottom"></div>
        <div className="tags">
          <p>
            <strong>
              {getLanguageFile(state.language).RiskManagement.documentCode}
            </strong>{" "}
            PLT_02
          </p>
          <p>
            <strong>
              {getLanguageFile(state.language).RiskManagement.issueDate}
            </strong>{" "}
            18.03.2026
          </p>
          <p>
            <strong>
              {getLanguageFile(state.language).RiskManagement.revisionCode}
            </strong>{" "}
            00
          </p>
          <p>
            <strong>
              {getLanguageFile(state.language).RiskManagement.revisionDate}
            </strong>{" "}
            ---
          </p>
        </div>
      </Modal.Body>
    </Modal>
  )
}

RiskManagementModal.propTypes = {
  showModal: PropTypes.boolean,
  onHide: PropTypes.any,
  state: PropTypes.any,
  getLanguageFile: PropTypes.any,
}

RiskManagementModal.defaultProps = {
  showModal: false,
}

export default RiskManagementModal
